import React from 'react';
import { palette } from 'app_previous/styles/colors';

interface ExclaimProps {
  fill?: string;
}

const Exclaim = ({ fill = palette.deepPurple }: ExclaimProps): JSX.Element => (
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24 12.8066C24 19.4341 18.6274 24.8066 12 24.8066C5.37258 24.8066 0 19.4341 0 12.8066C0 6.17922 5.37258 0.806641 12 0.806641C18.6274 0.806641 24 6.17922 24 12.8066ZM10.0833 5.80491C10.0378 4.71502 10.9092 3.80664 12 3.80664C13.0908 3.80664 13.9622 4.71501 13.9167 5.80491L13.5624 14.3079C13.5275 15.1456 12.8383 15.8066 12 15.8066C11.1617 15.8066 10.4725 15.1456 10.4376 14.3079L10.0833 5.80491ZM12 21.8066C13.1046 21.8066 14 20.9112 14 19.8066C14 18.7021 13.1046 17.8066 12 17.8066C10.8954 17.8066 10 18.7021 10 19.8066C10 20.9112 10.8954 21.8066 12 21.8066Z'
      fill={fill}
    />
  </svg>
);

export default Exclaim;
